import { useGetSetting } from "../../../../hooks/getSetting";

const getShouldAutoSubmit = (applicationForm) => {
  if (!applicationForm) return false;

  const [eeAutoSubmitEnabled] = useGetSetting(["ee.autosubmit-enabled"]);
  const isAutoSubmitEnabled = eeAutoSubmitEnabled?.includes(applicationForm?.applicationTemplateName);

  return isAutoSubmitEnabled && applicationForm?.shouldAutoSubmit === true;
};

export { getShouldAutoSubmit };
